// iPadOS 13+ hace que Safari (y Chrome/WebKit sobre iOS) envien el mismo
// user-agent que macOS de escritorio, sin ningun token que permita
// distinguirlos por string en el backend. Esta heuristica del lado del
// navegador (touch points + platform "Mac") es la unica senal confiable
// para detectar ese caso ambiguo.
export function getDeviceHint() {
  try {
    const isAppleTouchDesktopUA =
      navigator.maxTouchPoints > 1 && /Mac/i.test(navigator.platform);
    return isAppleTouchDesktopUA ? "tablet" : null;
  } catch (e) {
    return null;
  }
}
